import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoHistoryResponse, TaoHistoryArgs, TaoHistoryByIdArgs } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getOverallTaoHistory = async (params: TaoHistoryArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<TaoHistoryResponse>(buildApiUrl("taoHistory"), { params });
  return data;
};

const getTaoHistoryById = async (params: TaoHistoryByIdArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<TaoHistoryResponse>(buildApiUrl(`taoHistory/${params.taoId}`), { params });
  return data;
};

export const useOverallTaoHistory = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;
  const pageNumber = 0;
  const pageSize = 1400;


  return useQuery<TaoHistoryResponse, Error>({
    queryKey: ["Overall-Tao-History", requestedUser, pageNumber, pageSize],
    queryFn: () => getOverallTaoHistory({ practiceId, requestedUser, pageNumber, pageSize }),
  });
};

export const useTaoHistoryById = (taoId: number) => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;
  const pageNumber = 0;
  const pageSize = 1400;


  return useQuery<TaoHistoryResponse, Error>({
    queryKey: ["Tao-History-by-id", requestedUser, pageNumber, pageSize, taoId],
    queryFn: () => getTaoHistoryById({ practiceId, requestedUser, pageNumber, pageSize, taoId }),
  });
};
